import React, { useState } from 'react';
import { Row, Col, Form, Button, Input, Card, Table, Drawer, Popconfirm } from 'antd';
import { FormCadastroProdutoFornecedor } from './FormCadastroProdutoFornecedor';
import {v4} from 'uuid';

import {useRelacaoProdutoFornecedor} from './useRelacaoProdutoFornecedor';

const RelacaoProdutoFornecedor = () => {

    const [formRef] = Form.useForm();

    const [isCadastroVisibe, setCadastroVisible] = useState(false);

    const [listaDeRelacoes, setListaRelacoes] = useState([]);

    const [relacaoSelecionada, setRelacaoSelecionada] = useState(false);

    const [selectedRows, setSelectedRows] = useState([]);

    const {buscarRelacoes, removeRelacoes} = useRelacaoProdutoFornecedor();
    const [buscando, setBuscando] = useState(false);
    const [excluindo, setExcluindo] = useState(false);

    const novaRelacao = () => {
        setRelacaoSelecionada(false);
        setCadastroVisible(true);
    }

    const removeRelacoesHandler=async () =>{
        setExcluindo(true);
        try{
            await removeRelacoes(selectedRows.map(s => s.id));
            formRef.submit();
        } catch(e){
            console.log(e);
        } finally{
            setExcluindo(false);
        }
    }

    const permiteEditarRelacao  = () => {
        return selectedRows.length === 1;
    }

    const permiteExcluirRelacao  = () => {
        return selectedRows.length >= 1;
    }
    const editarRelacao = () => {
        setRelacaoSelecionada(selectedRows[0]);
        setCadastroVisible(true);
    }

    const buscaRelacoesHandle = async () => {
        console.log(formRef.getFieldValue("termo"));
        setSelectedRows([]);
        setBuscando(true)
        try{
            let relacoes = await buscarRelacoes(formRef.getFieldValue("termo"));
            relacoes = relacoes.map((relacao) => {
                relacao.key = relacao.id;
                return relacao;
            })
            setListaRelacoes(relacoes);
        } catch(err){
            console.log(err);
        } finally{
            setBuscando(false)
        }
    }
        

       
    const columns = [{
        title: "Codigo",
        dataIndex: "codigoProduto",
        key: "codigoProduto",
        sortDirections: ['descend', 'ascend'],
        sorter: (a, b) => (a.codigoProduto < b.codigoProduto ? -1 : a.codigoProduto > b.codigoProduto ? 1 : 0)
    },{
        title: "Descricao",
        dataIndex: "descricao",
        key: "descricao",
        sortDirections: ['descend', 'ascend'],
        sorter: (a, b) => (a.descricao < b.descricao ? -1 : a.descricao > b.descricao ? 1 : 0)
    },{
        title: "Unidade de Medida",
        dataIndex: "unMedida",
        key: "unMedida",
        sortDirections: ['descend', 'ascend'],
        sorter: (a, b) => (a.unidadeMedida < b.unidadeMedida ? -1 : a.unidadeMedida > b.unidadeMedida ? 1 : 0)
    },{
        title: "Codigo Fornecedor",
        dataIndex: "codigoProdutoFornecedor",
        key: "codigoProdutoFornecedor",
        sortDirections: ['descend', 'ascend'],
        sorter: (a, b) => (a.codigoProdutoFornecedor < b.codigoProdutoFornecedor ? -1 : a.codigoProdutoFornecedor > b.codigoProdutoFornecedor ? 1 : 0)
    },{
        title: "Unidade de Medida Fornecedor",
        dataIndex: "unMedidaFornecedor",
        key: "unMedidaFornecedor",
        sortDirections: ['descend', 'ascend'],
        sorter: (a, b) => (a.unidadeMedidaFornecedor < b.unidadeMedidaFornecedor ? -1 : a.unidadeMedidaFornecedor > b.unidadeMedidaFornecedor ? 1 : 0)
    }, {
        title: "Fator Multiplicacao",
        dataIndex: "fatorMultFornecedor",
        key: "fatorMultFornecedor",
        sortDirections: ['descend', 'ascend'],
        sorter: (a, b) => (a.fatorMultFornecedor < b.fatorMultFornecedor ? -1 : a.fatorMultFornecedor > b.fatorMultFornecedor ? 1 : 0)
       
    }];

    const onCloseHandle = (buscaNovamente = false) => {
        if(buscaNovamente){
            formRef.submit();
        }

        setCadastroVisible(false);
    }
 
    return (<>
        <Row>
            <Col span={24} style={{textAlign: "left", padding: "23px", paddingBottom: "0"}}>
                <h1>Produto vs Fornecedores</h1>
            </Col>
        </Row>
        <Form layout="inline" form={formRef} onFinish={buscaRelacoesHandle}>
            <Row style={{padding: "0 23px"}} align="bottom" gutter={[8,0]}>
                  
                  <Col>
                      <Row style={{fontSize: "12px"}}>
                          Termo de Busca
                      </Row>
                      <Row>
                          <Form.Item
                              name="termo"
                              initialValue=""
                          >
                              <Input prefix="Buscar Por:" />
                          </Form.Item>
                      </Row>
                      
                  </Col>
                  <Col>
                        <Form.Item>
                          <Button type="primary" htmlType="submit" loading={buscando}>Buscar</Button>
                        </Form.Item>
                   </Col>
                   <Col>
                        <Form.Item>
                          <Button type="default" onClick={(()=> novaRelacao())}>Nova Relação</Button>
                        </Form.Item>
                   </Col>
                   <Col>
                        <Form.Item>
                          <Button type="default" color="blue" onClick={(()=> editarRelacao())} disabled={!permiteEditarRelacao()}>Editar</Button>
                        </Form.Item>
                   </Col>
                   <Col>
                        <Form.Item>
                          <Popconfirm title="Tem certeza que deseja excluir os itens selecionados?" okText="Sim, excluir!" cancelText="Não" placement="bottom" onConfirm={removeRelacoesHandler}> 
                              <Button type="danger"  loading={excluindo} disabled={!permiteExcluirRelacao()}>Excluir</Button>
                          </Popconfirm>
                        </Form.Item>
                   </Col>
            </Row>
        </Form>

        <Row style={{marginTop: "12px", position: "sticky", top: "55px", zIndex: "9", background: "#FFF"}}>

            <Col span={24}>
                
                    <Table 
                          id="tblRelacao"
                          rowSelection={{
                              type: "checkbox",
                              selectedRowKeys: selectedRows.map(s => s.id),
                              onChange: (selectedRowKeys, selectedRows) => {
                                console.log('selectedRowKeys', selectedRowKeys);
                                console.log('selectedRows', selectedRows);
                                setSelectedRows(selectedRows);
                              }
                          }}

                          loading={buscando}
                        
                          pagination={false}
                          style={{
                              width: '100%'
                          }}
                          size="small"
                          
                          columns={columns}
                          dataSource={listaDeRelacoes}
                    ></Table>
                
            </Col>
        </Row>

        
        <FormCadastroProdutoFornecedor key={v4()} visible={isCadastroVisibe} onClose={onCloseHandle} relacao={relacaoSelecionada} onFinish={(result)=>{setCadastroVisible(false)}}></FormCadastroProdutoFornecedor>
        
    </>);
}

export {RelacaoProdutoFornecedor};